import { createResourceQuery } from '@faro/resource-query';
import { StudySpace } from '@faro/study-space-service-model';
import { AxiosError } from 'axios';
import { ServiceContextValue } from '../../../../context';
import { studySpaceEntityType } from '../../../../service';

export interface ParentSpaceData {
    spaces: StudySpace[];
}
export interface ParentSpaceDataQuery {
    studyDefinitionId: string;
}

export interface ParentSpaceResolverArgs {
    context: ServiceContextValue;
    query: ParentSpaceDataQuery;
}

export const dataHookId = 'parentSpaceData';

export const useParentSpaceNavLinkData = createResourceQuery<
    ParentSpaceData,
    ParentSpaceDataQuery,
    ServiceContextValue,
    AxiosError
>({
    id: dataHookId,
    resolve: async ({ context, query }: ParentSpaceResolverArgs) => {
        const { studySpaceService } = context;
        const { studyDefinitionId } = query;
        const spaces = await studySpaceService.list({ studyDefinitionId });
        return {
            spaces,
        };
    },
    queryKeys: [studySpaceEntityType],
});
